<template>
  <div>
    <div class="demand-list">
      <!-- サービス名 -->
      <a>{{ isInServicePeriod ? area.name : "Coming soon." }}</a>
      <!-- サービス毎の運行についてのURL(外部リンクを開く) -->
      <a
        style="text-align: right"
        @click="isInServicePeriod ? goToExternalLink(area.about_url) : null"
      >
        <img
          style="width: 5%; padding-right: 1%"
          :src="require(`@/assets/img/icon/png/info.png`)"
          class="romance-car"
        />運行について
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "DemandService",
  props: {
    area: {
      type: Object,
      required: true,
    },
    isInServicePeriod: {
      type: Boolean,
      required: true,
    },
  },
  setup() {},
};
</script>

<style scoped lang="scss">
.demand-list {
  padding: 20px 10px 5px;
  background: #f9f9f9;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  display: flex;

  a {
    font-size: 0.7rem;
    color: #888888;
    width: 50%;
    font-weight: bold;
  }
}
</style>
